import ComparisonContextBase from "./comparisonContextBase";
import { EyeTypes, OCTBrowserType } from "../config/config";
import store from "../store";

export default class CirrusComparisonBrowserContext extends ComparisonContextBase{
  constructor(exam, eye, initialBrowserType, launchOption, compareImgKey) {
    super(exam, eye, [OCTBrowserType.Cirrus, OCTBrowserType.Raster], initialBrowserType, "cirrusComparisonBody", "Cirrus Multiview", launchOption, compareImgKey);
    this.hasFoveaAlignControl = true;
  }

  get exams() {
    let exams, groupSplitExams = [];
    exams = this.eye === EyeTypes.OD ? this.odExams : this.osExams;
    let groupkey = this.eye === EyeTypes.OD ? "odGroups" : "osGroups";
    exams.forEach(e => {
      let groups = store.getters.groups(e, this.eye);
      if (store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType).length > 1) {
        groupSplitExams.push(...this.generateExamsFromGroup(e, groupkey, groups));
      }
      else {
        if (!e.octDateButtonText.includes(store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType))
          e.octDateButtonText = e.dateDisplay + " - " + store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType + " (" + e.exSrNo + ")";
        e.scanType = store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType;
        groupSplitExams.push(e);
      }
    });
    return groupSplitExams;
  }

  generateExamsFromGroup(exam, groupKey, groups) {
    let newExam, results = [];
    exam[groupKey].forEach(e => {
      // Filter ensures that the exam gets the proper groupSeriesType text
      if (groups.filter(f => f.groupSeriesType == e.groupSeriesType).length > 0) {
        newExam = Object.assign({}, exam);
        newExam.scanType = e.scanType;
        if (e.browserType != 1)
          newExam.octDateButtonText = exam.dateDisplay + " - " + e.eye + " " + e.groupSeriesType + " (" + exam.exSrNo + ")";
        else
          newExam.octDateButtonText = exam.dateDisplay + " - " + e.groupSeriesType + " (" + exam.exSrNo + ")";
        newExam[groupKey] = [e];
        results.push(newExam);
      }
    });
    return results;
  }

  reloadChildrenContext() {
    if (this.compare && this.compare.exam) {
      let exam = this.exams.filter(e => e.exSrNo == this.compare.exam.exSrNo && e.octDateButtonText.includes(this.compare.group.groupSeriesType));
      if (exam.length > 0) {
        this.compare.clearContext();
        this.selectCompare(this.compare.group, exam[0],this.compare.imgKey);
      }
    }
    if (this.baseline && this.baseline.exam) {
      let exam = this.exams.filter(e => e.exSrNo == this.baseline.exam.exSrNo && e.octDateButtonText.includes(this.baseline.group.groupSeriesType));
      if (exam.length > 0) {
        this.baseline.clearContext();
        this.selectBaseline(this.baseline.group, exam[0]);
      }
    }
  }
}